import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import get from "lodash/get";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonApiAction,
  CommonReducerAction,
  HolidayPlanInfo,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import createdeviceimg from "../../../../../Assets/Images/festivities.svg";
import PageNotFound from "../../../../../Component/NotFound/index";
import Stepper from "../../../../../Component/Stepper";
import { ApiReducerType } from "../../../../../Constants";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import HolidayApproval from "./holidayApproval";
import HolidayPlan from "./holidayPlan";
import HolidayPreferences from "./holidayPreferences";
import NameAndDescription from "./nameAndDesc";
import Preview from "./preview";
import { backToHome } from "../../../../../Handlers/setters";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

const currentYear = new Date().getFullYear();
class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      actionidList: "",
      headers: [
        {
          key: "holidayplanname",
          name: (
            <FormattedMessage
              id="LbHolidayplanname"
              defaultMessage="Holiday Plan Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
        {
          key: "duplicate",
          name: ``,
          type: TDTypeConsts.DUPLICATEHOLIDAY,
        },
      ],
      draftheaders: [
        {
          key: "holidayplanname",
          name: (
            <FormattedMessage
              id="LbHolidayplanname"
              defaultMessage="Holiday Plan Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
      ],
      value: 0,
      AllStep: [
        {
          step: 1,
          component: (
            <NameAndDescription
              onRef={(ref) =>
                this.setState({
                  child0: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbDescribe" defaultMessage="Describe" />,
          isError: false,
        },
        {
          step: 2,
          component: (
            <HolidayPreferences
              onRef={(ref) =>
                this.setState({
                  child1: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: (
            <FormattedMessage id="LbPreferences" defaultMessage="Preferences" />
          ),
          isError: false,
        },
        {
          step: 3,
          component: (
            <HolidayPlan
              onRef={(ref) =>
                this.setState({
                  child2: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbPlan" defaultMessage="Plan" />,
          isError: false,
        },
        {
          step: 4,
          component: (
            <HolidayApproval
              onRef={(ref) =>
                this.setState({
                  child3: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbApproval" defaultMessage="Approval" />,
          isError: false,
        },
        {
          step: 5,
          component: (
            <Preview
              onRef={(ref) =>
                this.setState({
                  child4: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                    onNext: this.OnSave,
                    nextButtonLabel: "Save",
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbPreview" defaultMessage="Preview" />,
        },
      ],
      completed: {},
      holidayplanname: "",
      parentid: null,
      currentRoute: "list",
      status: 1,
      holidayyear: currentYear.toString(),
      yearList: [],
      isPreviewEdit: true,
      permissions: { readOnly: false, editable: false },
      isDuplicateHoliday: false,
    };
  }

  onPrevClick = () => {
    this.child.handleBack();
  };

  componentWillMount() {
    this.props.ChangeLanguage("holidayplan");
    this.props.history.push(`${this.props.match.path}/list`);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("holidayConfig");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.CheckActiveSteps();
        this.GetYearList();
      });
    } else {
      backToHome();
      this.setState({ permissiondenied: true });
    }
  }

  componentWillReceiveProps(props) {
    if (props.history.location.pathname.includes("list")) {
      this.setState({ holidayplanname: "" });
    } else {
      const HolidayInfo = this.props.holidayPlanReducer;
      const holidayplanname = HolidayInfo.holidayplanname
        ? HolidayInfo.holidayplanname
        : "";
      this.setState({ holidayplanname });
    }
  }

  handleChange = (event, value) => {
    let status;
    value == 0 ? (status = 1) : value == 1 ? (status = 2) : (status = 0);
    this.setState({ value }, () => {
      const data = {
        holidayyear: this.state.holidayyear,
        statusid: status,
        offset: 0,
        limit: 50,
      };
      this.props.CommonApiAction(
        ApiReducerType.HOLIDAY_PLAN,
        "post",
        `leaves/getallholidayplan`,
        data,
      ).then((res) => {
        const list = res.value.data.result.map((x) => ({
          ...x,
          hideedit: this.state.holidayyear == currentYear ? false : this.state.holidayyear == currentYear+1 ? false : true,
        }));
        this.setState({list})
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    });
  };

  AddDefaultDataToReducer() {
    const HolidayInfo = this.props.holidayPlanReducer;

    // HolidayInfo.dayfornewemp = null,
    // HolidayInfo.maxoptlimit = null,
    // HolidayInfo.description = '',
    HolidayInfo.holidayplanid = 0;
    HolidayInfo.isdraft = true;
    HolidayInfo.holidayplanname = null;
    HolidayInfo.description = null;
    HolidayInfo.holidayyear = this.state.holidayyear;
    HolidayInfo.isrequiremandatory = true;
    HolidayInfo.isrequireoptional = false;
    HolidayInfo.holiday = [];
    HolidayInfo.isnotifyexisting = true;
    HolidayInfo.isnotifynew = true;
    HolidayInfo.lastdateexistingemp = null;
    HolidayInfo.optapplicationdate = null;
    HolidayInfo.dayfornewemp = null;
    HolidayInfo.maxoptlimit = null;

    this.props.HolidayPlanInfo({ ...HolidayInfo });
  }

  _onCreate = () => {
    const { match } = this.props;
    this.setState({ holidayplanname: "" });
    this.props.CommonReducerAction("CLEARHOLIDAYPLANINFO", {});
    this.AddDefaultDataToReducer();
    // let HolidayInfo = this.props.holidayPlanReducer
    // HolidayInfo.isdraft = true
    // HolidayInfo.optapplicationdate = HolidayInfo.optapplicationdate ? HolidayInfo.optapplicationdate : null
    // this.props.HolidayPlanInfo({ ...HolidayInfo})
    this.setState({ completed: {} });
    this.props.history.push(`${match.path}/create`);
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <FormattedMessage
            id="holidayConcept"
            defaultMessage="Holiday Lists as essentially lists of days on which an employee is not required to come to work owing to a festival, religiously important day or a national day."
          />
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  _renderCreate = () => (
    <React.Fragment>
      <CreateComp
        text={this.getText()}
        heading={
          this.state.value == 0 ? "Concept of Holiday" : "No drafts saved"
        }
        onCreate={this._onCreate}
        imageSrc={this.state.value == 0 ? createdeviceimg : emptylist}
        permissions={this.state.permissions}
      />
    </React.Fragment>
  );

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  GetYearList() {
    instance
      .get("leaves/holidayplanyear")
      .then((result) => {
        // const yearList = [];
        // yearList.push(
        //   ...result.data.result,
        // );
        this.setState(
          {
            yearList: result.data.result,
            holidayyear:
              result.data.result.length != 0
                ? `${
                    result.data.result[result.data.result.length - 1]
                      .displayname
                  }`
                : this.state.holidayyear,
          },
          () => {
            const data = {
              // holidayyear:
              //   result.data.result.length != 0
              //     ? `${
              //         result.data.result[result.data.result.length - 1]
              //           .displayname
              //       }`
              //     : this.state.holidayyear,
              holidayyear: this.state.holidayyear,
              statusid: this.state.status,
              offset: 0,
              limit: 50,
            };
            this.props.CommonApiAction(
              ApiReducerType.HOLIDAY_PLAN,
              "post",
              `leaves/getallholidayplan`,
              data,
            ).then((res) => {
              const list = res.value.data.result.map((x) => ({
                ...x,
                hideedit: this.state.holidayyear == currentYear ? false : this.state.holidayyear == currentYear+1 ? false : true,
              }));
              this.setState({list})
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response ? error.response.data.error.message : error.message,
                { variant: "error" },
              );
            });
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  updateYear = (event) => {
    const holidayyear = event.target.value;

    this.setState({ holidayyear }, () => {
      const data = {
        holidayyear: holidayyear == "Select Year" ? null : holidayyear,
        statusid: this.state.status,
        offset: 0,
        limit: 50,
      };
      this.props.CommonApiAction(
        ApiReducerType.HOLIDAY_PLAN,
        "post",
        `leaves/getallholidayplan`,
        data,
      ).then((res) => {
        console.log("res", res);
        const list = res.value.data.result.map((x) => ({
          ...x,
          hideedit: this.state.holidayyear == currentYear ? false : this.state.holidayyear == currentYear+1 ? false : true,
        }));
        this.setState({list})
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    });
  };

  _renderList = () => {
    const { HOLIDAY_PLAN } = this.props;
   

    return (
      <List
        // list={HOLIDAY_PLAN.Data}
        list={this.state.list}
        headers={this.state.value == 0 ? this.state.headers: this.state.draftheaders}
        headerIndex={0}
        module={"Holiday Plan"}
        onCreate={this._onCreate}
        onVersionChange={this.onVersionChange}
        onEdit={this.onEdit}
        updateYear={this.updateYear}
        showYearDropdown={true}
        yearList={this.state.yearList}
        holidayyear={this.state.holidayyear}
        goTo={this.props.goTo}
        sortOrder="desc"
        permissions={this.state.permissions}
        onEditAssignment={this.onEditAssignment}
      />
    );
  };

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          {/* <Tabs
                            value={this.state.value}
                            onChange={this.handleChange.bind(this)}
                            indicatorColor="primary"
                            textColor="primary"
                            scrollButtons="auto"
                            className="master-sh"
                        >
                            <Tab label={
                                <FormattedMessage id="LbActive" defaultMessage="Active" />
                            } className="tabheading" />
                            <Tab label={
                                <FormattedMessage id="LbDraft" defaultMessage="Draft" />
                            } className="tabheading" />
                        </Tabs> */}
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { HOLIDAY_PLAN } = this.props;
    const { yearList } = this.state;
    console.log("yearList: ", yearList);
    return (
      <div>
        {yearList.length < 1 ? this._renderCreate() : this._renderTab()}
        {/* {this._renderTab()} */}
      </div>
    );
  };

  _renderForm = () => {
    const { child0, child1, child2, child3, child4 } = this.state;
    const canSaveAsDraft =
      get(this.props, "holidayPlanReducer.isdraft", "") ||
      !get(this.props, "holidayPlanReducer.holidayplanid", "");
    const stepperchilds = [child0, child1, child2, child3, child4].filter(
      (x) => x,
    );
    !canSaveAsDraft &&
      stepperchilds.map((x) => {
        delete x.onSaveDraft;
        return x;
      });
    return (
      <div>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          completed={this.state.completed}
          setStep={this.setStep.bind(this)}
          childs={stepperchilds}
        />
       
      </div>
    );
  };

  DeleteHolidayPlan() {
    const HolidayInfo = this.props.holidayPlanReducer;
    const URL = `leaves/deleteholidayplan/${HolidayInfo.holidayplanid}/${HolidayInfo.holidayyear}`;
    instance
      .delete(URL)
      .then(() => {
        this.props.enqueueSnackbar("Holiday plan deleted successfully", {
          variant: "success",
        });
        this.OnCancel();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  _renderVersion = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        {this._renderList()}
      </Grid>
    </Grid>
  );

  onClick = () => {
    this.child.handleNext();
  };

  StepError(step, error) {
    const indextemp = this.state.AllStep.findIndex((x) => x.step == step);
    const { AllStep } = this.state;
    AllStep[indextemp].isError = error;
    this.setState({ AllStep });
  }

  GetHolidayPlanDetails(holidayplanid) {
    if (holidayplanid) {
      const URL = `/leaves/holidayplan/${holidayplanid}`;
      this.props.CommonReducerAction("CLEARHOLIDAYPLANINFO", {});
      instance
        .get(URL)
        .then((result) => {
          const HolidayInfo = result.data.result[0];
          const holidayplanname = HolidayInfo.holidayplanname
            ? HolidayInfo.holidayplanname
            : "";
          this.setState({ holidayplanname });
          this.props.HolidayPlanInfo({ ...HolidayInfo });
          this.props.history.push(`${this.props.match.path}/view`);
          const ispreview = true;
          this.CheckActiveSteps(ispreview);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  GetHolidayPlanDetails1(holidayplanid) {
    if (holidayplanid) {
      const URL = `/leaves/holidayplan/${holidayplanid}`;
    //  this.props.CommonReducerAction("CLEARHOLIDAYPLANINFO", {});
      instance
        .get(URL)
        .then((result) => {
          const HolidayInfo = result.data.result[0];

          HolidayInfo.holidayplanname = HolidayInfo.holidayplanname.concat("_new");
          
          const holidayplanname = HolidayInfo.holidayplanname
            ? HolidayInfo.holidayplanname.concat("_new")
            : "";
          this.setState({ holidayplanname });
          this.props.HolidayPlanInfo({ ...HolidayInfo });
          this.props.history.push(`${this.props.match.path}/create`);
          const ispreview = true;
          this.CheckActiveSteps(ispreview);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }


  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  CheckActiveSteps(ispreview) {
    const completed = {};
    const HolidayInfo = this.props.holidayPlanReducer;
    if (!this.isEmpty(HolidayInfo)) {
      HolidayInfo.holidayplanname != undefined
        ? (completed[0] = true)
        : (completed[0] = false);
      HolidayInfo.holidayyear != undefined
        ? (completed[1] = true)
        : (completed[1] = false);
      HolidayInfo.holiday && HolidayInfo.holiday.length > 0
        ? (completed[2] = true)
        : (completed[2] = false);
      HolidayInfo.lastdateexistingemp != undefined
        ? (completed[3] = true)
        : (completed[3] = false);
      // isApproval == true ? completed[3] = true : completed[3] = false
      HolidayInfo.isdraft == false && ispreview == true
        ? (completed[4] = true)
        : (completed[4] = false);
    }
    this.setState({ completed });
  }

  // DeleteHolidayPlan() {
  //     let attendanceDeviceInfo = this.props.attendanceDeviceReducer
  //     let URL = `attendance/devicepolicybyid/${attendanceDeviceInfo.devicepolicyid}`;
  //     instance.delete(URL).then(result => {
  //         this.props.enqueueSnackbar("Attendance device policy deleted successfully", { variant: 'success' })
  //         this.OnCancel();

  //     }).catch(error => {
  //         let CommonError = error.response
  //             ? error.response.data.error.message
  //             : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: 'error' })
  //     })

  // }

  onEdit = (item, isPreviewEdit) => {
    this.setState({ isPreviewEdit });
    // this.doEditId = item.holidayplanid;
    this.GetHolidayPlanDetails(item.holidayplanid);
  };

  ValidateAllSteps() {
    let isValid;
    const filteredArray = this.state.AllStep.filter(
      (array) => array.isError == true,
    );
    if (filteredArray.length != 0) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  OnSaveDraft = () => {
    this.OnSave(true);
  };

  OnSave = (isdraft = false) => {
    const HolidayInfo = this.props.holidayPlanReducer;
    if (!HolidayInfo.holidayplanname) {
      this.props.enqueueSnackbar("Please enter holiday plan name", {
        variant: "error",
      });
      return;
    }
    if (isdraft == false) {
      if (!HolidayInfo.lastdateexistingemp && HolidayInfo.isrequireoptional) {
        this.props.enqueueSnackbar("Please select date", { variant: "error" });
        return;
      }
      if (HolidayInfo.showHolidayApproval && HolidayInfo.isrequireoptional) {
        if (!HolidayInfo.dayfornewemp) {
          this.props.enqueueSnackbar("Please add days limit", {
            variant: "error",
          });
          return;
        } else if (!HolidayInfo.maxoptlimit && HolidayInfo.isrequireoptional) {
          this.props.enqueueSnackbar("Please add number of optional holidays", {
            variant: "error",
          });
          return;
        }
      }
    }
    if (!this.ValidateAllSteps()) {
      this.props.enqueueSnackbar("Please provide valid information", {
        variant: "error",
      });
    } else {
      HolidayInfo.isdraft = isdraft == true ? true : false;
      HolidayInfo.holidayplanid = this.state.isDuplicateHoliday ? null : HolidayInfo.holidayplanid;
      const URL = "leaves/holidayplan";
      instance
        .post(URL, HolidayInfo)
        .then((result) => {
          if (isdraft == true) {
            HolidayInfo.holidayplanid = result.data.result[0].holidayplanid;
            this.props.HolidayPlanInfo({ ...HolidayInfo });
            this.props.enqueueSnackbar(
              "Holiday plan saved as a draft successfully",
              { variant: "success" },
            );
          } else {
            this.props.enqueueSnackbar("Holiday plan saved successfully", {
              variant: "success",
            });
            this.GetYearList();
            this.OnCancel();
          }
          const data = {
            holidayyear: this.state.holidayyear,
            statusid: this.state.status,
            offset: 0,
            limit: 50,
          };
          this.props.CommonApiAction(
            ApiReducerType.HOLIDAY_PLAN,
            "post",
            `leaves/getallholidayplan`,
            data,
          ).then((res) => {
            const list = res.value.data.result.map((x) => ({
              ...x,
              hideedit: this.state.holidayyear == currentYear ? false : this.state.holidayyear == currentYear+1 ? false : true,
            }));
            this.setState({list})
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response ? error.response.data.error.message : error.message,
              { variant: "error" },
            );
          });
          this.setState({isDuplicateHoliday:false});
          this.props.history.push("list");
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  };

  EditPreview = () => {
    this.props.history.push(`${this.props.match.path}/create`);
  };

  onEditAssignment = (item) => {
    this.setState({ isPreviewEdit: false, isDuplicateHoliday: true });
     this.GetHolidayPlanDetails1(item.holidayplanid);
  };

  

  OnCancel = () => {
    const { AllStep } = this.state;
    for (const step of AllStep) {
      step.isError = false;
    }
    this.setState({
      value: 0,
      AllStep,
      completed: {},
      holidayplanname: "",
      activeStep: "",
      isDuplicateHoliday:false
    });
    this.props.CommonReducerAction("CLEARHOLIDAYPLANINFO", {});
    this.props.history.push("./list");
    const data = {
      holidayyear: this.state.holidayyear,
      statusid: this.state.status,
      offset: 0,
      limit: 50,
    };
    this.props.CommonApiAction(
      ApiReducerType.HOLIDAY_PLAN,
      "post",
      `leaves/getallholidayplan`,
      data,
    ).then((res) => {
      const list = res.value.data.result.map((x) => ({
        ...x,
        hideedit: this.state.holidayyear == currentYear ? false : this.state.holidayyear == currentYear+1 ? false : true,
      }));
      this.setState({list})
    })
    .catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  };

  _renderView = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <Preview onRef={() => {}} />
        {this.state.isPreviewEdit ? (
          <div>
            <div className="deletebutton-wrapper">
              <div className="deletebutton-innerwrapper">
                {this.state.permissions.editable ? (
                  <span className="deletebutton1">
                    <span className="delete-option">
                      <span
                        style={{ float: "left", margin: "0px 8px 0px 4px" }}
                      >
                        Are you sure?
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.DeleteHolidayPlan()}
                      >
                        <svg
                          className="message-edit cursour-pointer save-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#fff"
                            d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.OnCancel()}
                      >
                        <svg
                          className="message-edit cursour-pointer close-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          onClick={() => this.OnCancel()}
                        >
                          <path
                            fill="#fff"
                            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                          ></path>
                        </svg>
                      </span>
                    </span>

                    <svg
                      className="delete-svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z" />
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                    </svg>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.OnCancel()}
              >
                <span className="floatleft" style={{ marginLeft: 6 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </span>
                <span className="draftclosebutton-text">Close</span>
              </div>
              {this.state.permissions.editable ? (
                <div
                  className="draftbutton-innerwrapper cursour-pointer"
                  onClick={() => this.EditPreview()}
                >
                  <span className="editbutton">
                    <span className="edit-option">Edit</span>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </span>
                  {/* <span><DoneAllIcon /> <span className="draft-option">Save </span></span>  */}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          // <div className="draftclosebutton cursour-pointer" onClick={() => this.OnCancel()}><span className="draftclosebutton-text">Close</span> X </div>
          <div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.OnCancel()}
              >
                <span className="draftclosebutton-text">Close</span> X{" "}
              </div>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );

  render() {
    const { classes, match } = this.props;
    const language = this.props.Language.holidayplan;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <Helmet>
            <title>{headersList.Config.HolidayPlan.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <div>
                {this.props.history.location.pathname ===
                  "/config/track/leave/holiday/list" && (
                  <div className="common-menubar-header">
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}
                      indicatorColor="#fff"
                      textColor="primary"
                      scrollButtons="auto"
                    >
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbActive"
                            defaultMessage="Active"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbDraft"
                            defaultMessage="Draft"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border"></div>
                  </div>
                )}
              </div>
              <main className="content-outer-wrapper-with-tab">
                <div className={classes.root}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sm={12}
                      className="device-wrapper"
                    >
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}/create`}
                          render={this._renderForm}
                        />
                        <Route
                          exact
                          path={`${match.path}/list`}
                          render={this._renderComponent}
                        />
                        <Route
                          exact
                          path={`${match.path}/`}
                          render={this._renderComponent}
                        />
                        <Route
                          exact
                          path={`${match.path}/view`}
                          render={this._renderView}
                        />
                        <Route path="**" component={PageNotFound} />
                      </Switch>
                    </Grid>
                  </Grid>
                </div>
              </main>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

index.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  HOLIDAY_PLAN: state.HOLIDAY_PLAN,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      CommonApiAction: (type, method, url, data) =>
        CommonApiAction(type, method, url, data),
      setHelperText: (data) => setHelperText(data),
      HolidayPlanInfo: (data) => HolidayPlanInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
